import { FormControl, InputLabel } from "@mui/material";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux"
import { BlueHoverButton } from "../../components/Inputs/BlueHoverButton";
import { WhiteInput } from "../../components/Inputs/InputText";
import Lista from "../../components/Lista"
import Popup from "../../components/Popup";
import servAnalises from "../../services/login/servAnalises";
import ResultadoAnalise from "../SolicitacaoVistoria/ResultadoAnalise";
import { columnsSolicitacaoVistoriaAnalise } from "./Lista";
import stylesAnaliseVistoria from "./SolicitacaoVistoriaAnalise.module.css";
import { ImagensCod } from "./ImagensCod/ImagensCod";
import servParam from "../../services/login/servParam";

const SolicitacaoVistoriaAnalise = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [filtro, setFiltro] = useState("");
    const [openAnaliseVistoria, setOpenAnaliseVistoria] = useState(false);
    const [recordForView, setRecordForView] = useState(null);
    const [analisesSolicitacao, setAnalisesSolicitacao] = useState([]);
    const [openAnexosModal, setOpenAnexosModal] = useState(false);
    const [codigoSelecionado, setCodigoSelecionado] = useState(null);
    const [parametros, setParametros] = useState(null);

    const analises = useSelector((state) => state.analises);

    const onClickPesquisar = async () => {
        try {

            setIsLoading(true);

            const data = await servAnalises.ListarSolicitacoesVistoriaAnalise(analises.codigoSolicitacaoDeVistoria, filtro);

            let analiseSolic = data.Content;

            analiseSolic.map((analise) => {
                analise.id = analise.Id
            });

            setAnalisesSolicitacao(analiseSolic);

            setIsLoading(false);

        } catch (err) {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        const recuperarParametrosVistoria = async () => {
            try {
                setIsLoading(true);

                const data = await servParam.solicitacaoVistoriaParametros();
                setParametros(data);
                setIsLoading(false);
            } catch (err) {
                setIsLoading(false);
            }
        }

        recuperarParametrosVistoria();
    }, [recordForView]);

    useEffect(() => {

        const recuperarAnalisesAnteriores = async () => {
            try {
                setIsLoading(true);

                const data = await servAnalises.ListarSolicitacoesVistoriaAnalise(analises.codigoSolicitacaoDeVistoria, "");

                let analiseSolic = data.Content;

                analiseSolic.map((analise) => {
                    analise.id = analise.Id;
                })

                setAnalisesSolicitacao(analiseSolic);

                setIsLoading(false);
            } catch (err) {
                setIsLoading(false);
            }
        }

        if (analises.codigoSolicitacaoDeVistoria) {
            recuperarAnalisesAnteriores();
        }
    }, [analises]);

    const handleOpenAnexos = (codigo) => {
        setCodigoSelecionado(codigo);
        setOpenAnexosModal(true);
    };

    return (
        <div className={stylesAnaliseVistoria.solicitacaoContainer}>
            <h2 style={{ margin: 0 }}>Análises da solicitação de vistoria</h2>
            <div className={stylesAnaliseVistoria.solicitacaoFiltros}>
                <FormControl>
                    <InputLabel shrink style={{ color: "#B8B8B8" }}>Data de apresentação</InputLabel>
                    <WhiteInput
                        value={filtro}
                        onChange={(e) => setFiltro(e.target.value)}
                        type="date"
                        id="pesquisa-data"
                        sx={{ width: "500px", marginRight: "10px" }}
                    />
                </FormControl>
                <BlueHoverButton onClick={onClickPesquisar} variant="contained" style={{ marginTop: "15px" }} >
                    Pesquisar
                </BlueHoverButton>
            </div>
            <div>
                <Lista
                    columns={columnsSolicitacaoVistoriaAnalise(handleOpenAnexos, parametros)}
                    rows={analisesSolicitacao}
                    onDblClick={setOpenAnaliseVistoria}
                    setSelectedData={setRecordForView}
                    hideFooter={true}
                    autoHeight={true}
                />
            </div>
            <Popup title="Análise da solicitação de vistoria" openPopup={openAnaliseVistoria} setOpenPopup={setOpenAnaliseVistoria} >
                <ResultadoAnalise
                    record={recordForView}
                    setOpen={setOpenAnaliseVistoria}
                />
            </Popup>

            <Popup
                title="Galeria de Imagens COD"
                openPopup={openAnexosModal}
                setOpenPopup={setOpenAnexosModal}
            >
                <ImagensCod
                    codigoCod={codigoSelecionado}
                    setOpen={setOpenAnexosModal}
                    recordForView={recordForView}
                />
            </Popup>
        </div>
    )
}

export { SolicitacaoVistoriaAnalise }